<template>
    <div id="modalDownloadCountDetail" class="modal_size">

        <a href="javascript:" class="ui_close" type="button" rel="modal:close" @click="$emit('close')"><span class="sr_only">popup close</span></a>
        <dl class="modal_content">
            <dt class="ellipsis maintit">
                <i>Download Count Detail</i>
            </dt>
            <dd>
                <div class="view_cont">
                    <!-- Grid -->
                    <div class="grid_wrap">
                        <!-- Grid Count-->
                        <div class="grid_total">
                            Total Count
                            <em>{{ resultCount | numberFormat }}</em>
                        </div>
                        <!-- Grid -->
                        <div id="grid">
                            <toast-grid
                                gridId="gridContentHistoryDownloadCount"
                                :key="gridKey"
                                :data="gridData"
                                :columns="gridColumns"
                                :options="gridOptions"
                                :pageOptions="gridPageOptions"
                                :theme="gridTheme"
                                :isTotalCount="false"
                            />
                        </div>

                        <div class="paginate">
                            <sdl-pagination
                                :current-page="currentPage"
                                :total-rows="resultCount"
                                :per-page="perPage"
                                @change="onGoToPage"
                                align="center"
                            />
                        </div>
                    </div>

                    <div class="btn_wrap topLine">
                        <div class="btn_right">
                            <a href="javascript:" class="btn_white" @click="$emit('close')">Close</a>
                        </div>
                    </div>
                </div>
            </dd>
        </dl>
    </div>
</template>

<script>

import { mapGetters } from 'vuex';

import axios from 'axios';
import $ from 'jquery';

import qs from 'query-string';
import moment from 'moment';

import { SDLUtil, StringUtil, DateUtil } from '@/utils';

import DatePicker from '~c/DatePicker';

import HhpCerts from '~c/HhpCerts';

import Pagination from '@/components/common/control/pagination/Pagination';
import ToastGrid from '~c/ToastGrid';

export default {
    name: '',
    components: {
        'toast-grid': ToastGrid,
        'sdl-pagination': Pagination,
    },
    props: [ 'cttid' ],
	data() {
		return {
            searchParams: {
                cttid: this.cttid,
            },

            resultCount: 0,

            currentPage: 1,
            perPage: parseInt(localStorage.getItem('listRows') || 10),

            gridKey: 0,
            gridData: [],
            gridColumns: [
                {
                    header: 'User ID',
                    name: 'USER_ID',
                    width: 100,
                    align: 'left',
                    resizable: true,
                    sortable: false,
                },
                {
                    header: 'Date',
                    name: 'DL_DATE',
                    width: 140,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'IP Address',
                    name: 'USER_IP',
                    width: 120,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'VPATH',
                    name: 'VPATH',
                    align: 'left',
                    resizable: true,
                    sortable: false,
                },
                {
                    header: 'Country',
                    name: 'COUNTRY',
                    width: 60,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'Model',
                    name: 'MODEL',
                    width: 80,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'Content Type',
                    name: 'TYPE',
                    width: 140,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'Category',
                    name: 'CATEGORY',
                    width: 70,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'Buyer',
                    name: 'BUYER',
                    width: 60,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
            ],
            gridOptions: {
                scrollX: true,
                scrollY: false,
            },
            gridPageOptions: null,
            gridTheme: {
                name: 'skpTheme', // required
                value: {
                    // required
                    row: {
                        hover: {
                            background: '#FBFBFC',
                        },
                    },
                    // cell: {
                    //     normal: {
                    //         background: '#00ff00',
                    //         border: '#e0e0e0'
                    //     },
                    //     head: {
                    //         background: '#ff0000',
                    //         border: '#ffff00'
                    //     },
                    // },
                },
            },

		}
	},
	computed: {

	},
	methods: {
        async initLoad() {
            SDLUtil.showLoadingBar(true);
            await this.fetchData(this.cttid, this.currentPage).then(this.setData);
            SDLUtil.showLoadingBar(false);
        },
        fetchData(cttid, pageNo) {
            if (!pageNo) pageNo = 1;

            return axios
                // Loads data such as list of countries, etc...
                .get(`${SDLUtil.API_URL}/basis/anysvcmobile/contenthistory/DownsDetailPop.skp`, {
                    params: {
                        page: pageNo,
                        cttid: cttid,
                    },
                })
                .then(res => {
                    console.log('fetchData: res', res);
                    return res.data;
                })
                .catch(err => {
                    console.log('fetchData: err', err);
                });

        },
        setData(data) {
            const { count, rows } = data;
            this.resultCount = count;

            const gridData = rows.map(item => {
                if (typeof item.CATEGORY === 'undefined') {
                    item.CATEGORY = '';
                }
                if (typeof item.BUYER === 'undefined') {
                    item.BUYER = '';
                }
                return item;
            });

            this.setGridData(gridData);
            return ;
        },
        setGridData(data) {
            this.gridData = data;
            this.gridKey += 1;

        },
        onGoToPage(pageNo) {
            this.goToPage(pageNo);
        },
        async goToPage(pageNo) {
            SDLUtil.showLoadingBar(true);
            this.currentPage = pageNo;
            await this.fetchData(this.cttid, this.currentPage).then(this.setData);
            SDLUtil.showLoadingBar(false);
        },

	},
	created() {
        this.initLoad();

	},
	mounted() {

	},
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/anysvcmobile/contentHistory/DownloadCountDetailPopup.vue